<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<span class="content_title">
				{{ title }}
			</span>
			<el-row>
				<el-col :span="7" class="panelContainer">
					<span class="jiliwenzi">
						{{ motivationText }}
					</span>
					<span class="clickCardSpan" @click="handleEmployeeCard">
						<p>{{ currentTime }}</p>
						<p>打卡</p>
					</span>
				</el-col>
				<el-col :span="16" class="panelContainer">
					<el-table :cell-class-name="$moneyCellClass"
						:data="listData"
						:loading="loading"
						border
						stripe
						:highlight-selection-row="true"
						style="border-radius: 10px"
						empty-text="暂无数据"
						:header-cell-style="{ backgroundColor: '#b3e0ff' }"
						height="100%"
					>
						<el-table-column prop="rowNumber" label="序号" align="center" width="80" is-keep="true"></el-table-column>
						<el-table-column prop="storeName" label="门店名称" is-keep="true" min-width="120" align="center"></el-table-column>
						<el-table-column prop="userName" label="员工姓名" min-width="100" align="center"></el-table-column>
						<el-table-column prop="cardTime" label="打卡时间" min-width="180" align="center"></el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</topTab>
		<!-- 打卡 -->
		<el-dialog :visible.sync="dialogVisible" title="员工打卡" style="width: 60%; margin: auto" :close-on-click-modal="false">
			<span style="display: block; margin-bottom: 10px"><strong>员工:</strong></span>
			<el-select v-model="selectedUser" placeholder="请选择员工" filterable style="width: 100%">
				<el-option v-for="item in userList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
			</el-select>
			<template #footer>
				<span>
					<el-button @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" :loading="isSubmitting" @click="handleConfirmCard">确认</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
import { GetAttendanceDayList, AddAttendance } from "@/api/storeCostApi.js";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "考勤打卡"
				}
			],
			loading: false, // 显示加载
			listData: [],
			dialogVisible: false,
			selectedUser: "",
			userList: [],
			formInline: {
				pageIndex: 1,
				pageSize: 99999
			},
			title: "考勤打卡",
			dateStr: new Date(),
			currentTime: "",
			motivationText: "",
			isSubmitting: false, // 防重复提交标志
			motivationTexts: [
				"每天进步一点点，成功就会离你越来越近！",
				"工作是为了更好的生活，努力是为了更好的自己。",
				"今天的努力，明天的收获，加油！",
				"积极的心态，能让一切变得更美好。",
				"每一个清晨，都是新的开始！",
				"用心工作，快乐生活，享受每一天。",
				"努力不一定成功，但放弃一定失败。",
				"相信自己，你比想象中更强大！",
				"细节决定成败，态度决定一切。",
				"行动是成功的阶梯，越努力越幸运！"
			]
		};
	},
	// 注册组件
	components: {},
	created() {
		this.getListData();
		this.title = "门店今日考勤打卡";
		this.GetUserBindSelectByPermission();
		this.updateCurrentTime();
		// 随机选择一条激励文字
		this.selectMotivationText();
		// 每秒更新一次时间
		setInterval(() => {
			this.updateCurrentTime();
		}, 1000);
	},
	computed: {},
	methods: {
		changePages() {},
		// 获取列表
		getListData() {
			this.loading = true;
			GetAttendanceDayList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 更新当前时间
		updateCurrentTime() {
			this.currentTime = this.getCurrentTime();
		},
		// 随机选择激励文字
		selectMotivationText() {
			const randomIndex = Math.floor(Math.random() * this.motivationTexts.length);
			this.motivationText = this.motivationTexts[randomIndex];
		},
		getCurrentTime() {
			const now = new Date();
			const year = now.getFullYear();
			const month = now.getMonth() + 1;
			const date = now.getDate();
			const hours = now.getHours();
			const minutes = now.getMinutes();
			const seconds = now.getSeconds();

			return `${year}-${this.fillZero(month)}-${this.fillZero(date)} ${this.fillZero(hours)}:${this.fillZero(minutes)}:${this.fillZero(seconds)}`;
		},
		fillZero(num) {
			return num < 10 ? "0" + num : num;
		},
		// 打卡
		handleEmployeeCard() {
			this.dialogVisible = true;
		},
		// 确认打卡
		handleConfirmCard() {
			// 防止重复点击
			if (this.isSubmitting) {
				return;
			}

			if (!this.selectedUser) {
				this.$message.error("请选择员工");
				return;
			}

			this.isSubmitting = true;
			const paramer = {
				keyId: this.selectedUser
			};
			AddAttendance(paramer)
				.then((res) => {
					this.isSubmitting = false;
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "打卡成功"
						});
						this.dialogVisible = false;
						this.selectedUser = "";
						this.getListData();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.isSubmitting = false;
					this.$message.error("打卡失败，请稍后再试！");
				});
		},
		// 获取员工列表信息
		GetUserBindSelectByPermission() {
			GetUserBindSelectByPermission({})
				.then((res) => {
					if (res.code == 1) {
						this.userList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取员工列表失败，请稍后再试！");
				});
		}
	}
};
</script>

<style scoped lang="scss">
.content_title {
	font-size: 32px;
	font-weight: 700;
	display: block;
	text-align: center;
	margin-bottom: 20px;
}

.panelContainer {
	border-radius: 15px;
	height: 700px;
	background-color: #fff;
	margin-right: 10px;
	padding: 20px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.jiliwenzi {
	font-size: 16px;
	color: #333;
	text-align: center;
	margin-bottom: 30px;
	max-width: 100%;
	word-wrap: break-word;
	line-height: 1.5;
}

.clickCardSpan {
	font-size: 24px;
	font-weight: 700;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	color: #fff;
	margin: auto;
	width: 300px;
	height: 300px;
	border-radius: 150px;
	background-color: cornflowerblue;
	cursor: pointer;
	/* 闪烁的外阴影效果 */
	animation: shadowBlink 2s infinite;
	transition: background-color 0.3s ease, transform 0.3s ease;
}

.clickCardSpan p {
	margin: 5px 0;
	line-height: 1.2;
}

.clickCardSpan:hover {
	background-color: #4a76ff;
	transform: scale(1.05);
}

@keyframes shadowBlink {
	0%,
	100% {
		box-shadow: 0 0 15px 5px rgba(79, 192, 210, 0.7);
	}

	50% {
		box-shadow: 0 0 30px 10px rgba(79, 192, 210, 0.7);
	}
}
</style>
